import React from 'react';
import _get from 'lodash/get';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { SESSION_STATE } from '../../constants/AssessmentConstants';
import useMatch from '../../hooks/useMatch';
import ROUTE_CONSTANTS from '../../constants/RouteConstants';

export default function TestReportRoute({ children, exact, path }) {
  const test = useSelector(state => state.test);
  const { usertype } = useSelector(state => state.auth.initUserDetails);
  const {
    is_onboarded,
    is_expired,
    slug: testSlug,
    test_type: testType,
    invite_id,
    session_state,
  } = test;
  const isCustomFormEnabled = _get(
    test,
    'settings.hacker_extra_data.custom_data.enabled'
  );

  const isReportPage = useMatch(ROUTE_CONSTANTS.REPORT_ROUTE);

  let hasAccess = true;
  let redirectPath = `/test-report/${testSlug}`;
  let search;

  /**
   * If test has not ended, and onboarding custom form is enabled,
   * and if onboarding is not done, and if the user is a hacker
   * redirect to onboarding
   */
  if (
    is_expired === false &&
    isCustomFormEnabled === true &&
    is_onboarded === false &&
    testSlug &&
    usertype === 'hacker' &&
    testType === 'LRN'
  ) {
    hasAccess = false;
    search = `?inviteId=${invite_id}`;
    redirectPath = `/${testSlug}/onboarding/form`;

    /**
     * If test has not ended, and if the user is a hacker,
     * redirect to instruction
     */
  } else if (
    (is_expired === false &&
      isCustomFormEnabled === true &&
      is_onboarded === true &&
      testSlug &&
      usertype === 'hacker' &&
      testType === 'LRN' &&
      session_state !== SESSION_STATE.END) ||
    (is_expired === false &&
      testSlug &&
      isCustomFormEnabled === false &&
      usertype === 'hacker' &&
      testType === 'LRN' &&
      session_state !== SESSION_STATE.END)
  ) {
    hasAccess = false;
    redirectPath = `/test/${testSlug}`;

    /**
     * If it is recruiter and if test has not expored or
     * if the test is not part of learn module
     * redirect to instruction
     */
  } else if (
    (is_expired === false &&
      testSlug &&
      usertype === 'recruiter' &&
      testType === 'LRN') ||
    (testType !== 'LRN' && testSlug)
  ) {
    hasAccess = false;
    redirectPath = `/test/${testSlug}`;
  }
  // @Todo add onboarding check after this

  return (
    <Route
      exact={exact}
      path={path}
      render={props =>
        hasAccess ? (
          <>{children}</>
        ) : (
          <>
            {!isReportPage && (
              <Redirect
                to={{
                  pathname: redirectPath,
                  search,
                  state: { from: props.location },
                }}
              />
            )}
          </>
        )
      }
    />
  );
}
